import React, { useState } from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import TagInput from 'shared/components/TagInput';
import Button from 'shared/components/NewButton';
import { ModalWithGreyHeader } from 'shared/components/Modals';

import { shareTender, resetErrors } from './ducks';

import styles from './styles.module.scss';

const ShareTenderModal = ({
  errors,
  closeModal,
  tenderId,
  shareTender,
  isSubmitting,
  resetErrors,
  canSubmit
}) => {
  const [emails, setEmails] = useState([]);

  const errorMessage = _.head(errors[0]);

  const handleSubmit = () => {
    if (canSubmit) {
      shareTender({ emails, tenderId, closeModal });
    }
  };

  return (
    <ModalWithGreyHeader header="Share Project" closeModal={closeModal}>
      <label className={styles.label}>Invite via email address</label>
      <TagInput
        tags={emails}
        onlyUnique={true}
        handleChange={emails => {
          setEmails(emails);
          resetErrors();
        }}
        inputProps={{
          placeholder: _.isEmpty(emails) ? 'Enter emails...' : ''
        }}
      />
      {errorMessage && <div className={styles.error}>{errorMessage}</div>}
      <div className={styles.tip}>
        Tip: enter multiple addresses using spaces or commas to separate them.
      </div>

      <Button
        color="lightBlue"
        size="medium"
        className={styles.button}
        disabled={
          _.isEmpty(emails) || isSubmitting || errorMessage || !canSubmit
        }
        onClick={handleSubmit}>
        Send Invite
      </Button>
    </ModalWithGreyHeader>
  );
};

const mapStateToProps = (state, props) => {
  const { errors, isSubmitting } = state.shared.shareTenderModal;

  return { errors, isSubmitting };
};

const mapDispatchToProps = {
  resetErrors,
  shareTender
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareTenderModal);
